var _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueButtonWithRad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 26,
    viewBox: "0 0 70 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.004)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1720",
    width: 70,
    height: 26,
    rx: 4,
    transform: "translate(0 .004)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(57 16.004)",
    style: {
      fill: "#fff",
      fontSize: 10,
      fontFamily: "NunitoSans-Bold,Nunito Sans",
      fontWeight: 700,
      letterSpacing: ".05em"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -44.21,
    y: 0
  }, "BUTTON")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueButtonWithRad);
export default __webpack_public_path__ + "static/media/BlueButtonWithRad.f67fc2b67f02d9351f48de5da5f44951.svg";
export { ForwardRef as ReactComponent };